import { datadogRum } from '@datadog/browser-rum';
import { useFlag } from '@unleash/proxy-client-react';

import { FeatureFlagName } from './featureFlags.constants';

/**
 * Hook to check if a feature flag is enabled.
 * Returns false by default if the flag doesn't exist or Unleash is unavailable.
 */
export const useFeatureFlag = (flagName: FeatureFlagName): boolean => {
  const flagValue = useFlag(flagName);
  datadogRum.addFeatureFlagEvaluation(flagName, flagValue);
  return flagValue;
};

export default useFeatureFlag;
